import { saveFBFormSuccess, getFormTypesList, getFormFieldTypesList, updateFBFormField, removeFBFormField, updateFBFormForm, getFBFormSubmission, updateFBFormSubmissionForm, saveFBFormSubmissionForm, updateFBFormSubmission, saveFBFormSubmissionFormSuccess, saveFBFormSubmissionFormFail, finishFBFormSubmissionForm, finishFBFormSubmissionFormSuccess, finishFBFormSubmissionFormFail, clearFormFill } from './../../../../core/store/form-builder/form-builder.actions';
import { FBFormFieldModel, FBFormModel, FBFormSubmissionModel, FBFormFieldValueModel, FBFormLanguageModel, FBFormFieldGroupModel } from './../../../../models/formBuilderModels';
import { interval, Subject, takeUntil, tap } from 'rxjs';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../../../../core/store';
import { EmailValidator, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { markFormGroupTouched, getAllControlsErrors, updateFormGroupValidity, deepClone, formatDateString } from './../../../../../app/helpers/utils';
import { BaseComponent } from './../../../../core/abstracts/baseComponent';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { AlertService } from 'src/app/shared/services/alert.service';
import { clearForm, getFBForm, saveFBForm } from 'src/app/core/store/form-builder/form-builder.actions';
import { fillFormBuilder, initFormBuilderForm, initFormBuilderSubmissionForm, parseField } from 'src/app/core/store/form-builder/form-builder.reducer';
import { OverlayPanel } from 'primeng/overlaypanel';
import { environment } from 'src/environments/environment';
import { MultiSelect } from 'primeng/multiselect';
import { FormBuilderService } from '../../../../core/services/formBuilder.service';

@Component({
    selector: 'app-form-fill',
    templateUrl: './form-fill.component.html',
    styleUrls: ['./form-fill.component.scss'],
    standalone: false
})
export class FormFillComponent extends BaseComponent implements OnInit, OnDestroy {

  private readonly autoSaveIntervalMs = 30000;
  private readonly currentI9ConditionalFieldNames = [
    'i9AlienAuthorizationExpirationDate',
    'i9AuthorizedDocumentType',
    'i9USCIS',
    'label2',
    'i9i94AdmissionNumber',
    'label3',
    'i9ForeignPassportNumber',
    'i9ForeignPassportCountry'
  ];
  private destroy$ = new Subject<void>();
  private saveWasAutoSave = false;

  @Input() formSubmissionID: number;
  @Input() formID: number;
  @Input() jobApplicationID: number;
  @Input() prospectiveCandidateID: number;
  @Input() readOnly: boolean;
  @Input() hideSaveButon: boolean;
  @Input() hideTitle: boolean;
  @Input() forceFullWidth: boolean;
  @Input() doNotNavigate: boolean;
  @Input() hideFinishAndSign: boolean;
  @Input() hideAutoSaveStatus: boolean;
  @Output() autoSaved = new EventEmitter<Date>();



  fbForm: FBFormModel;
  formSubmission: FBFormSubmissionModel;
  form: UntypedFormGroup;
  formFieldTypeOptions = [];
  formTypeOptions = [];
  savingForm = false;
  finishingForm = false;
  autoSaving = false;
  autoSaveFailed = false;
  lastAutoSaved: Date | null = null;
  loadingForm = false;
  @Input() backLink: string;
  @Input() editingAsHR: boolean;
  @Input() isPrefillingForm: boolean = false;

  isUsedAsComponent;

  yesNoOptions = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ];

  formLanguageOptions = [];
  selectedFormLanguage: FBFormLanguageModel;

  constructor(
    private actions$: Actions,
    private alertService: AlertService,
    private formBuilderService: FormBuilderService,
    private store: Store<State>,
    private route: ActivatedRoute,
    private router: Router) {
    super();
  }

  ngOnInit() {
    this.store.dispatch(clearFormFill());
    this.route.queryParams.subscribe(queryParams => {
      if (queryParams.backLink) {
        if (!this.backLink) {
          this.backLink = queryParams.backLink;
        }
      }
      if (queryParams.editingAsHR) {
        this.editingAsHR = queryParams.editingAsHR === 'true';
      }
    });

    if (this.formID) {
      this.isUsedAsComponent = true;
      this.store.dispatch(getFBFormSubmission({ formID: this.formID, formSubmissionID: this.formSubmissionID, jobApplicationID: this.jobApplicationID, prospectiveCandidateID: this.prospectiveCandidateID }));
    }
    this.route.params.subscribe(params => {
      this.route.queryParams.subscribe(query => {
        if (params.formID) {
          this.formSubmissionID = params.formSubmissionID?.split('?')[0]; 

          this.store.dispatch(getFBFormSubmission({
            formID: params.formID,
            formSubmissionID: this.formSubmissionID,
            jobApplicationID: this.jobApplicationID,
            prospectiveCandidateID: this.prospectiveCandidateID
          }));
        }
      });
    });


    this.subs.push(
      this.store.select(s => s.formBuilderState.form).subscribe(fbForm => {
        if (fbForm) {
          let loadingFBFormFirstTime = false;
          if (!this.fbForm) {
            loadingFBFormFirstTime = true;
          }
          this.fbForm = deepClone(fbForm);

          this.loadLanguages();
          this.loadFields();

          if (loadingFBFormFirstTime && (!this.fbForm.formFields || this.fbForm.formFields.length === 0)) {
            this.finish();
          }

          this.store.dispatch(updateFBFormSubmission({
            formSubmission: {
              formID: this.fbForm.id,
              fbFormFieldValues: [],
              fbForm: this.fbForm,
            }
          }));
        }
      }),
      this.store.select(s => s.formBuilderState.formSubmission).subscribe(formSubmission => {
        if (formSubmission) {
          this.formSubmission = deepClone(formSubmission);
          this.formSubmissionID = formSubmission.id;
          if (formSubmission.isCredentialTransitionOffer)
          {
            this.fbForm = formSubmission.fbForm;
            this.loadingForm = false;
            return;
          }
          if (!this.fbForm) {
            this.fbForm = this.formSubmission.fbForm;

            this.loadLanguages();
            this.loadFields();

            if (this.fbForm.formFields && this.fbForm.formFields.length === 0) {
              if (!this.form) {
                this.initForm();
              }
              this.finish();
            }
          }
          if (!this.form) {
            this.initForm();
          }
        }
      }),
      this.store.select(s => s.formBuilderState.formTypes).subscribe(formTypes => {
        if (formTypes) {
          this.formTypeOptions = formTypes.map(x => ({ label: x.formType, value: x.id }));
        }
      }),
      this.store.select(s => s.formBuilderState.formFieldTypes).subscribe(formFieldTypes => {
        if (formFieldTypes) {
          this.formFieldTypeOptions = formFieldTypes.map(x => ({ label: x.formFieldType, value: x.id }));
        }
      }),
      this.store.select(s => s.formBuilderState.loadingForm).subscribe(loadingForm => {
        this.loadingForm = loadingForm;
      }),
      this.store.select(s => s.formBuilderState.savingFormSubmission).subscribe(savingFormSubmission => {
        this.savingForm = savingFormSubmission;
      }),

      this.actions$.pipe(
        ofType(saveFBFormSubmissionFormSuccess),
        tap(action => {
          if (this.saveWasAutoSave) {
            const savedAt = new Date();
            this.saveWasAutoSave = false;
            this.autoSaving = false;
            this.autoSaveFailed = false;
            this.lastAutoSaved = savedAt;
            this.form?.markAsPristine();
            this.autoSaved.emit(savedAt);
            return;
          }

          if (!this.isUsedAsComponent && !this.doNotNavigate) {
            this.alertService.success('Form saved!');
            this.router.navigate([this.getBackLink()], { relativeTo: this.route });            
          }
        })
      ).subscribe(),

      this.actions$.pipe(
        ofType(saveFBFormSubmissionFormFail),
        tap(action => {
          if (this.saveWasAutoSave) {
            this.saveWasAutoSave = false;
            this.autoSaving = false;
            this.autoSaveFailed = true;
          }
        })
      ).subscribe(),

      this.actions$.pipe(
        ofType(finishFBFormSubmissionFormSuccess),
        tap(action => {
          this.finishingForm = false;

          if (!this.doNotNavigate) {
            this.alertService.success('Form Finished!');
            let HRQueryParams = {};
            if (this.editingAsHR) {
              HRQueryParams = { signingAsHR: true };
            }
            if (this.route.snapshot.params.formSubmissionID) {
              this.router.navigate(['../../../sign/' + action.formSubmission.id], { relativeTo: this.route, queryParams: HRQueryParams });
            } else {
              this.router.navigate(['../../sign/' + action.formSubmission.id], { relativeTo: this.route, queryParams: HRQueryParams });
            }
          }

        })
      ).subscribe(),

      this.actions$.pipe(
        ofType(finishFBFormSubmissionFormFail),
        tap(() => {
          this.finishingForm = false;
        })
      ).subscribe()
    );

    this.store.dispatch(getFormTypesList());
    this.store.dispatch(getFormFieldTypesList());
    this.startAutoSave();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    super.ngOnDestroy();
  }

  private startAutoSave() {
    interval(this.autoSaveIntervalMs)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.autoSave());
  }

  public autoSave() {
    this.saveSubmission(true);
  }

  private loadFields() {
    if (this.fbForm.formFields) {
      if (this.editingAsHR) {
        this.fbForm.formFields = this.fbForm.formFields.filter(x => x.isHRField);
      } else {
        this.fbForm.formFields = this.fbForm.formFields.filter(x => !x.isHRField);
      }
      this.fbForm.formFields = this.fbForm.formFields.filter(x => !x.inactive);
      this.fbForm.formFields = this.fbForm.formFields.sort((a, b) => a.fieldOrder > b.fieldOrder ? 1 : -1);
      this.fbForm.formFields.forEach(f => {
        parseField(f, this.fbForm, this.selectedFormLanguage);
      });
    }
  }

  loadLanguages() {
    if (this.fbForm.formLanguages && this.fbForm.formLanguages.length > 0) {
      this.formLanguageOptions = this.fbForm.formLanguages.map(x => ({ label: x.languageName, value: x }));
      this.formLanguageOptions.unshift({ label: 'English', value: { languageID: null, languageCode: 'us', languageName: 'English' } });
      if (this.formSubmission.languageID) {
        this.selectedFormLanguage = this.formLanguageOptions.find(x => x.value.languageID === this.formSubmission.languageID).value;
      } else {
        this.selectedFormLanguage = this.formLanguageOptions[0].value;
      }
    } else {
      this.formLanguageOptions = [];
    }
  }

  getBackLink() {
    if (this.route.snapshot.params.formSubmissionID) {
      return this.backLink ? this.backLink : '../../../list';
    } else {
      return this.backLink ? this.backLink : '../../list';
    }

  }
  initForm() {
    this.form = initFormBuilderSubmissionForm(this.fbForm);
    this.subs.push(
      this.form.valueChanges.subscribe(formValues => {
        const formErrors = getAllControlsErrors(this.form);
        this.store.dispatch(updateFBFormSubmissionForm({ formValues, formErrors }));
      }));
    fillFormBuilder(this.form, this.fbForm, this.formSubmission, this.selectedFormLanguage);
    this.initializeCurrentI9IdentificationValueHandling();

  }

  getFieldTypeLabel(field: FBFormFieldModel) {
    const formFieldTypeOption = this.formFieldTypeOptions.find(x => x.value === field.fieldTypeID);
    if (formFieldTypeOption) {
      return formFieldTypeOption.label;
    }
  }

  public save() {
    this.saveSubmission(false);
  }

  private saveSubmission(isAutoSave: boolean) {
    if (this.formSubmission?.isCredentialTransitionOffer)
      return;

    if (isAutoSave && !this.canAutoSave()) {
      return;
    }

    if (!isAutoSave && this.readOnly) {
      return;
    }

    if (!this.form || !this.formSubmission || !this.fbForm) {
      return;
    }

    this.saveWasAutoSave = isAutoSave;
    this.autoSaving = isAutoSave;
    this.autoSaveFailed = false;
    this.store.dispatch(saveFBFormSubmissionForm({ formSubmission: this.getSubmissionToSave(this.formSubmission, this.fbForm) }));
  }

  private canAutoSave() {
    if (this.formSubmission?.isCredentialTransitionOffer)
      return false;

    if (!this.form || !this.form.dirty || this.readOnly || this.savingForm || this.autoSaving || !this.formSubmission || !this.fbForm) {
      return false;
    }

    const canEditSignedHRFields = this.editingAsHR && this.formSubmission.signedDate && !this.formSubmission.signedByHRDate;
    if (this.formSubmission.optOutDate || (this.formSubmission.signedDate && !canEditSignedHRFields)) {
      return false;
    }

    return true;
  }

  getFieldValuesToSave(fbValue: FBFormFieldModel): FBFormFieldValueModel[] {
    let result: FBFormFieldValueModel[] = [];

    var value = this.getFieldValue(fbValue);
    if (this.isCurrentI9ConditionalField(fbValue))
      value = this.form.get(fbValue.formControlIdentifier)?.value;

    if (this.containsOther(fbValue)) {
      if (fbValue && fbValue.formFieldType.formFieldType === 'Many Options') {
        value = this.getFieldValue(fbValue) + "<;>" + this.form.get(fbValue.formControlIdentifier + "Other").value;
      } else if (this.form.get(fbValue.formControlIdentifier + "Other")) {
        value = this.form.get(fbValue.formControlIdentifier + "Other").value;
      }
    }

    result.push({
      formFieldID: fbValue.id,
      entryNumber: fbValue.entryNumber,
      readOnly: fbValue.readOnly,
      value: value
    });
    if (fbValue.sectionFields && fbValue.sectionFields.length > 0) {
      for (var i = 0; i < fbValue.sectionFields.length; i++) {
        this.getFieldValuesToSave(fbValue.sectionFields[i]).forEach(fv =>
          result.push(fv)
        );
      }
    }

    return result;
  }

  getSubmissionToSave(formSubmission: FBFormSubmissionModel, fbForm: FBFormModel) {
    const submissionToSave: FBFormSubmissionModel = deepClone(this.formSubmission);
    submissionToSave.fbFormFieldValues = [];
    for (const fbValue of fbForm.formFields) {//.filter(f => this.form.get(f.formControlIdentifier))) {
      this.addSubmissionValues(fbValue, submissionToSave);


    }
    return submissionToSave;
  }
  addSubmissionValues(fbValue: FBFormFieldModel, submissionToSave: FBFormSubmissionModel) {
    if (fbValue.formFieldType.formFieldType == "Section") {
      if (fbValue.sections) {
        for (const section of fbValue.sections) {
          for (const sectionFBValue of section.formFields) {
            this.addSubmissionValues(sectionFBValue, submissionToSave);
          }
        }
      }
    }
    else if (this.form.get(fbValue.formControlIdentifier) && !this.isInactiveCurrentI9Field(fbValue)) {
      this.getFieldValuesToSave(fbValue).forEach(fv =>
        submissionToSave.fbFormFieldValues.push(fv)
      );
    }
  }

  isFormValid() {
    if (this.form) {
      return this.form.valid;
    } else {
      return false;
    }
  }

  forceValidation() {
    updateFormGroupValidity(this.form);
    markFormGroupTouched(this.form);
  }

  finish() {
    if (this.formSubmission?.isCredentialTransitionOffer)
      return;

    if (this.readOnly || this.finishingForm || this.savingForm) {
      return;
    }

    updateFormGroupValidity(this.form);
    if (this.form.valid) {
      this.saveWasAutoSave = false;
      this.autoSaving = false;
      this.finishingForm = true;
      this.savingForm = true;
      this.store.dispatch(finishFBFormSubmissionForm({ formSubmission: this.getSubmissionToSave(this.formSubmission, this.fbForm) }));
    } else {
      markFormGroupTouched(this.form);
    }
  }

  containsOther(field: FBFormFieldModel) {
    if (this.formSubmission && this.formSubmission.fbFormFieldValues) {
      const fieldValue = this.formSubmission.fbFormFieldValues.find(x => x.formFieldID.toString() === field.id.toString());
      if (field.formFieldType.formFieldType === 'One Option') {
        return fieldValue && fieldValue.value
          && (fieldValue.value === 'Other' || !field.fieldOptions.split('\n').some(x => x === fieldValue.value));
      } else if (field.formFieldType.formFieldType === 'Many Options') {
        return fieldValue && fieldValue.value && fieldValue.value.indexOf('Other') >= 0;
      }
    }
  }


  getFieldValue(field: FBFormFieldModel) {
    if (this.formSubmission && this.formSubmission.fbFormFieldValues) {
      const fieldValue = this.formSubmission.fbFormFieldValues.find(x => x.formFieldID.toString() === field.id.toString());
      if (fieldValue) {
        if (fieldValue.formField && fieldValue.formField.formFieldType && fieldValue.formField.formFieldType.formFieldType == "Many Options" && fieldValue.value) {
          let options;
          if (field.optionsTable) {
            options = field.fieldOptions.split('\n')
              .map(x => ({ label: (x.split('|')[1] ? x.split('|')[1] : x.split('|')[0]), value: x.split('|')[0] }));
          } else {
            options = field.fieldOptions.split('\n').map(x => ({ label: x, value: x }));
          }
          var result = [];
          var valuesList = fieldValue.value.split(",");
          options.forEach(fv => {
            if (valuesList.indexOf(fv.value) >= 0)
              result.push(fv.value);
          });
          return result.join("<;>");
        }
        return fieldValue.value;
      }
    }
  }

  getFieldFileName(field: FBFormFieldModel) {
    if (this.formSubmission && this.formSubmission.fbFormFieldValues) {
      const fieldValue = this.formSubmission.fbFormFieldValues.find(x => x.formFieldID.toString() === field.formControlIdentifier);
      if (fieldValue) {
        return fieldValue.fileName;
      }
    }
  }

  getFieldFileUrl(field: FBFormFieldModel) {
    if (this.formSubmission && this.formSubmission.fbFormFieldValues) {
      const fieldValue = this.formSubmission.fbFormFieldValues.find(x => x.formFieldID.toString() === field.formControlIdentifier);
      if (fieldValue) {
        return fieldValue.fileDownloadUrl;
      }
    }
  }

  openMultiSelect(multiselect: MultiSelect) {
    multiselect.show();
  }

  showField(field: FBFormFieldModel) {

    if (field.sectionFormFieldID) {
      return false;
    }
    if (!field.formControlIdentifier || !this.form.get(field.formControlIdentifier.toString()))
      return false;

    let formControl = this.form.get(field.formControlIdentifier.toString());

    const currentI9Visibility = this.getCurrentI9FieldVisibility(field);
    if (currentI9Visibility !== null) {
      formControl.clearValidators();
      if (currentI9Visibility.show && currentI9Visibility.required)
        formControl.setValidators(Validators.required);
      formControl.updateValueAndValidity({ emitEvent: false });
      return currentI9Visibility.show;
    }

    if (!field.relatedFormField)
      return true;
    else {
      let showField = true;
      if (field.relatedFormFieldID) {
        if (field.showIfRelatedAnswerIs.startsWith('>')) {
          showField = Number(this.getFieldValue(field.relatedFormField)) > Number(field.showIfRelatedAnswerIs.replace('>', ''));
        } else if (field.showIfRelatedAnswerIs.startsWith('<')) {
          showField = Number(this.getFieldValue(field.relatedFormField)) < Number(field.showIfRelatedAnswerIs.replace('<', ''));
        } else {
          showField = this.getFieldValue(field.relatedFormField) === field.showIfRelatedAnswerIs;
        }
      }

      formControl.clearValidators();
      if (showField) {
        let validators = [];

        if (field.formFieldType.formFieldType === 'Email') {
          validators.push(Validators.email);
        }
        if (field.formFieldType.formFieldType === 'Phone') {
          validators.push(Validators.pattern('^[+]{0,1}[0-9]{0,4}[( ]{0,2}[0-9]{3,4}[-) ]{0,2}[0-9]{3,4}[-]{0,1}[0-9]{4,5}$'));
        }
        if (field.formFieldType.formFieldType === 'Number') {
          validators.push(Validators.pattern('^([0-9]*[.])?[0-9]+$'));
        }

        if (showField) {//make it required
          if (field.isRequired)
            validators.push(Validators.required);
        }
        formControl.setValidators(validators);
      }
      return showField;
    }
  }

  useI9DocumentSelector(): boolean {
    return this.fbForm?.isI9 === true && this.editingAsHR === true && !this.readOnly;
  }

  shouldRenderRegularField(field: FBFormFieldModel): boolean {
    if (!this.useI9DocumentSelector())
      return true;

    return ![
      'titleHR2', 'titleHR21', 'titleHR22', 'titleHR3', 'titleHR4', 'titleHR5',
      'A1DocumentTitle', 'A1IssuingAuthority', 'A1DocumentNumber', 'A1DocumentExpirationDate',
      'A2DocumentTitle', 'A2IssuingAuthority', 'A2DocumentNumber', 'A2DocumentExpirationDate',
      'A3DocumentTitle', 'A3IssuingAuthority', 'A3DocumentNumber', 'A3DocumentExpirationDate',
      'B1DocumentTitle', 'B1IssuingAuthority', 'B1DocumentNumber', 'B1DocumentExpirationDate',
      'C1DocumentTitle', 'C1IssuingAuthority', 'C1DocumentNumber', 'C1DocumentExpirationDate'
    ].includes(field.fieldName);
  }

  private getCurrentI9FieldVisibility(field: FBFormFieldModel): { show: boolean, required: boolean } | null {
    if (this.fbForm?.isI9 !== true || this.editingAsHR)
      return null;

    const status = this.getI9FieldControlValue('i9USSituation');
    const documentType = this.getI9FieldControlValue('i9AuthorizedDocumentType');
    const isPermanentResident = status === 'A lawful permanent resident';
    const isAuthorizedToWork = status === 'An alien authorized to work';

    switch (field.fieldName) {
      case 'i9AlienAuthorizationExpirationDate':
        return { show: isAuthorizedToWork, required: false };
      case 'i9AuthorizedDocumentType':
        return { show: isAuthorizedToWork, required: isAuthorizedToWork };
      case 'label2':
      case 'label3':
        return { show: isAuthorizedToWork && !documentType, required: false };
      case 'i9USCIS': {
        const show = isPermanentResident || (isAuthorizedToWork && (!documentType || documentType === 'Alien Registration Number/USCIS Number'));
        return { show, required: isPermanentResident || documentType === 'Alien Registration Number/USCIS Number' };
      }
      case 'i9i94AdmissionNumber': {
        const show = isAuthorizedToWork && (!documentType || documentType === 'Form I-94 Admission Number');
        return { show, required: documentType === 'Form I-94 Admission Number' };
      }
      case 'i9ForeignPassportNumber':
      case 'i9ForeignPassportCountry': {
        const show = isAuthorizedToWork && (!documentType || documentType === 'Foreign Passport Number');
        return { show, required: documentType === 'Foreign Passport Number' };
      }
      default:
        return null;
    }
  }

  private getI9FieldControlValue(fieldName: string): string {
    const targetField = this.fbForm.formFields.find(x => x.fieldName === fieldName);
    return targetField?.formControlIdentifier
      ? this.form.get(targetField.formControlIdentifier.toString())?.value
      : null;
  }

  private initializeCurrentI9IdentificationValueHandling(): void {
    if (this.fbForm?.isI9 !== true || this.editingAsHR)
      return;

    const canClearInactiveValues = this.inferLegacyI9AuthorizedDocumentType();

    ['i9USSituation', 'i9AuthorizedDocumentType'].forEach(fieldName => {
      const field = this.fbForm.formFields.find(x => x.fieldName === fieldName);
      const control = field?.formControlIdentifier ? this.form.get(field.formControlIdentifier.toString()) : null;
      if (control)
        this.subs.push(control.valueChanges.subscribe(() => this.clearInactiveCurrentI9Values()));
    });

    if (canClearInactiveValues)
      this.clearInactiveCurrentI9Values();
  }

  private inferLegacyI9AuthorizedDocumentType(): boolean {
    if (this.getI9FieldControlValue('i9USSituation') !== 'An alien authorized to work'
      || this.getI9FieldControlValue('i9AuthorizedDocumentType'))
      return true;

    const populatedDocumentTypes = [
      {
        documentType: 'Alien Registration Number/USCIS Number',
        hasValue: !!this.getI9FieldControlValue('i9USCIS')
      },
      {
        documentType: 'Form I-94 Admission Number',
        hasValue: !!this.getI9FieldControlValue('i9i94AdmissionNumber')
      },
      {
        documentType: 'Foreign Passport Number',
        hasValue: !!this.getI9FieldControlValue('i9ForeignPassportNumber')
          || !!this.getI9FieldControlValue('i9ForeignPassportCountry')
      }
    ].filter(x => x.hasValue);

    if (populatedDocumentTypes.length === 0)
      return true;

    if (populatedDocumentTypes.length > 1)
      return false;

    const documentTypeField = this.fbForm.formFields.find(x => x.fieldName === 'i9AuthorizedDocumentType');
    const documentTypeControl = documentTypeField?.formControlIdentifier
      ? this.form.get(documentTypeField.formControlIdentifier.toString())
      : null;
    documentTypeControl?.setValue(populatedDocumentTypes[0].documentType, { emitEvent: false });
    return true;
  }

  private clearInactiveCurrentI9Values(): void {
    const status = this.getI9FieldControlValue('i9USSituation');
    const documentType = this.getI9FieldControlValue('i9AuthorizedDocumentType');
    const activeFields = new Set<string>();

    if (status === 'A lawful permanent resident') {
      activeFields.add('i9USCIS');
    } else if (status === 'An alien authorized to work') {
      activeFields.add('i9AlienAuthorizationExpirationDate');
      activeFields.add('i9AuthorizedDocumentType');
      if (documentType === 'Alien Registration Number/USCIS Number') {
        activeFields.add('i9USCIS');
      } else if (documentType === 'Form I-94 Admission Number') {
        activeFields.add('i9i94AdmissionNumber');
      } else if (documentType === 'Foreign Passport Number') {
        activeFields.add('i9ForeignPassportNumber');
        activeFields.add('i9ForeignPassportCountry');
      }
    }

    let valuesChanged = false;
    this.currentI9ConditionalFieldNames
      .filter(fieldName => !activeFields.has(fieldName))
      .forEach(fieldName => {
        const field = this.fbForm.formFields.find(x => x.fieldName === fieldName);
        const control = field?.formControlIdentifier ? this.form.get(field.formControlIdentifier.toString()) : null;
        if (control && control.value !== null && control.value !== undefined && control.value !== '') {
          control.setValue('', { emitEvent: false });
          valuesChanged = true;
        }
      });

    if (valuesChanged)
      this.form.updateValueAndValidity({ emitEvent: true });
  }

  private isCurrentI9ConditionalField(field: FBFormFieldModel): boolean {
    return this.fbForm?.isI9 === true && this.currentI9ConditionalFieldNames.includes(field?.fieldName);
  }

  private isInactiveCurrentI9Field(field: FBFormFieldModel): boolean {
    const visibility = this.getCurrentI9FieldVisibility(field);
    return visibility !== null && !visibility.show;
  }

  changedFile(fileInput, field: FBFormFieldModel) {
    if (fileInput.target.files.length > 0) {
      this.savingForm = true;
      var file = fileInput.target.files[0];
      this.formBuilderService.uploadValueFieldFile(this.formSubmission.id, field.id, file).subscribe(fileId => {
        this.savingForm = false;
        if (fileId > 0) {
          this.form.get(field.id.toString()).setValue(fileId.toString());
          this.form.markAsDirty();
          var fieldValue = this.formSubmission.fbFormFieldValues.find(x => x.formFieldID.toString() === field.id.toString());
          if (fieldValue) {
            fieldValue.fileName = file.name;
          }
        }
      });
    }
  }

  deleteFile(field: FBFormFieldModel) {
    var fieldValue = this.formSubmission.fbFormFieldValues.find(x => x.formFieldID.toString() === field.id.toString());
    if (fieldValue) {
      fieldValue.value = null;
      fieldValue.fileName = null;
      this.form.get(field.id.toString()).setValue("");
      this.form.markAsDirty();
    }
  }

  changedLanguage() {
    this.form?.markAsDirty();
    this.store.dispatch(updateFBFormSubmission({
            formSubmission: {
              languageID: this.selectedFormLanguage.languageID
            }
          }));
  }

  getFormName(fbForm: FBFormModel) {
    let formLanguage;
    if (this.selectedFormLanguage && this.selectedFormLanguage.languageID) {
      formLanguage = fbForm.formLanguages.find(x => x.languageID === this.selectedFormLanguage.languageID);
      if (formLanguage && formLanguage.name) {
        return formLanguage.name;
      }
    }

    return fbForm.name;
  }

  getFieldGroupName(currentFormFieldGroup: FBFormFieldGroupModel) {
    if (currentFormFieldGroup) {
      let formFieldGroupLanguage;
      if (this.selectedFormLanguage && this.selectedFormLanguage.languageID) {
        formFieldGroupLanguage = currentFormFieldGroup.formFieldGroupLanguages.find(x => x.languageID === this.selectedFormLanguage.languageID);
        if (formFieldGroupLanguage && formFieldGroupLanguage.groupName) {
          return formFieldGroupLanguage.groupName;
        }
      }

      return currentFormFieldGroup.groupName;
    }
    return '';
  }

}
